module.exports = __webpack_public_path__ + "static/media/kudos-no-data-bg.dc5de76a.svg";